import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { GeonameThirdOrder } from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

/**
 * Hook to fetch third-order administrative divisions for a second-order division
 * @param geonameId the geonameId of the second-order division
 */
export function useChildrenDivisions(geonameId: number | null) {
  const { token } = useAuth()
  const url = geonameId ? `/api/geonames/${geonameId}/children` : null
  const { data, error, mutate } = useGet<ApiResponse<GeonameThirdOrder[]>>(
    token && url ? url : null,
    undefined,
    token ?? '',
  )

  return {
    children: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
